<template>
  <div style="height: 100%">
    <transition name="slidedealer" mode="in-out">
      <div :key="view" class="transition">
        <component v-if="!loading" :is="view"></component>
      </div>
    </transition>
  </div>
</template>

<script>
import queryString from "query-string";
import DecorativeCoating from "./DecorativeCoating.vue";
import Register from "./Register.vue";
import CustomerAddress from "./CustomerAddress.vue";
import CustomerForm from "./CustomerForm.vue";
import PainterQuotation from "./PainterQuotation.vue";
import DealerQuotation from "./DealerQuotation.vue";
import Product from "./Product.vue";
import Cart from "./Cart.vue";
import ShippingCar from "./ShippingCar.vue";
import PaySolutionGateway from "./PaySolutionGateway.vue";
import OTP from "./OTP.vue";
import Login from "./Login.vue";
import OrderSummary from "./OrderSummary.vue";
import Agreement from "./Agreement.vue";
import OrderView from "./OrderView.vue";
import ShippingCarDealer from "./ShippingCarDealer.vue";
import SelectPainter from "./SelectPainter.vue";
import ReviewPainter from "./ReviewPainter.vue";
import PainterForm from "./PainterForm.vue";
import WorkForm from "./WorkForm.vue";
import BillUpload from "./BillUpload.vue";
import PainterHistory from "./PainterHistory.vue";
import PainterProfile from "./PainterProfile/index.vue";
import ForgetPassword from "./ForgetPassword.vue";
import CustomerProfile from "./CustomerProfile.vue";
import DealerProfile from "./DealerProfile";
import DealerAddress from "./DealerAddress";
import SlipUpload from "./SlipUpload";
import PainterPhotos from "./PainterPhotos";

import axios from "axios";

export default {
  components: {
    DecorativeCoating,
    Register,
    CustomerAddress,
    CustomerForm,
    PainterQuotation,
    DealerQuotation,
    Product,
    Cart,
    ShippingCar,
    PaySolutionGateway,
    OTP,
    Login,
    OrderSummary,
    Agreement,
    OrderView,
    ShippingCarDealer,
    SelectPainter,
    PainterForm,
    ReviewPainter,
    WorkForm,
    BillUpload,
    PainterHistory,
    ForgetPassword,
    CustomerProfile,
    PainterProfile,
    DealerProfile,
    DealerAddress,
    SlipUpload,
    PainterPhotos,
  },
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    var vm = this;
    vm.queryinit();

    await vm.init();
    await vm.trackEvent();
    vm.loading = false;
  },
  methods: {
    async init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // var liffid = this.$liffid.home;
        if (this.query.apptype == "line") {
          if (
            [
              "111430663950288",
              "102915644812388",
              "102028964902390",
              "102968804806798",
            ].includes(this.query.pageid)
          ) {
            var liffid = "1654404151-o7xeY592";
          } else if (
            ["112016050658927", "148559413337"].includes(this.query.pageid)
          ) {
            var liffid = "1654981837-K1Mz5rwm";
          }
          await this.initializeLiff(liffid);
          resolve();
        } else if (this.query.apptype == "facebook") {
          vm.$store.state.userid = vm.query.userid;
          window.extAsyncInit = function () {
            // the Messenger Extensions JS SDK is done loading
            vm.loading = false;
            resolve();
          };
        } else {
          vm.$store.state.userid =
            "Uc40ec9623e7a01d8293897a3d5dac51c__102028964902390";
          vm.loading = false;
          vm.$store.state.profile = {
            displayName: "วรัญญู",
            pictureUrl:
              "https://profile.line-scdn.net/0hx0iKvpHAJx9UMg7A13pYSGh3KXIjHCFXLFVoeCIycCktATRLbgc8KXlhKnsqBGlNalVqfXAxeS1w",
            userId: "Uc40ec9623e7a01d8293897a3d5dac51c",
            // userId: "Uc40ec9623e7a01d8293897a3d5dac51c",
          };
        }
      });
    },
    async initializeLiff(myLiffId) {
      return new Promise(async (resolve) => {
        var vm = this;
        var redirectUri = window.location.href;
        try {
          await this.$liff.init({
            liffId: myLiffId,
          });
          if (await this.$liff.isLoggedIn()) {
            this.$store.state.profile = await this.$liff.getProfile();
            vm.$store.state.userid =
              this.$store.state.profile.userId + "__" + this.query.pageid;
            resolve();
          } else {
            await this.$liff.login({ redirectUri });
            resolve();
          }
        } catch (error) {
          console.log(error);
          resolve();
          // alert(error.message);
        }
      });
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
      if (vm.$store.state.query.group) {
        // vm.$store.state.query.group = vm.$store.state.query.group.replace(
        //   "bobo",
        //   "#"
        // );
        Object.assign(
          vm.$store.state.query,
          queryString.parse(
            "group=" + decodeURIComponent(vm.$store.state.query.group)
          )
        );
      }
      if (vm.$store.state.query.main_category) {
        vm.$store.state.query.main_category = vm.$store.state.query.main_category.replace(
          "bobo",
          "&"
        );
      }
    },
    trackEvent() {
      var vm = this;
      var currentView = this.query.view;
      if (currentView.toLowerCase() == "paysolutiongateway") {
        currentView = "ชำระผ่านระบบ";
      } else if (currentView.toLowerCase() == "slipupload") {
        currentView = "อัพโหลดสลิป";
      }
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        webviewevent: currentView,
      };
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toatrackusers-webviewevent",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              resolve();
            }
          });
      });
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
};
</script>

<style>
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
/* // router view */
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
/* // router view back */

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 75px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
